declare var tinymce: any;
import naja from 'naja';

export default class Editable {
    static init(): void {
        if (typeof tinymce === 'undefined') {
            return;
        }

        tinymce.init({
            entity_encoding: "raw",
            selector: 'span[contenteditable=true], div[contenteditable=true]',
            // forced_root_block: "", // zakomentováno aby dále fungovalo přidávání nových odstavců
            inline: true,
            plugins: [
                'advlist autolink link image lists charmap print preview hr anchor pagebreak',
                'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking',
                'save table contextmenu directionality emoticons template paste textcolor'
            ],
            toolbar: 'insertfile undo redo | styleselect | sizeselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | save',

            formats: {
                desktopBlock: { inline: 'span', classes: 'd-md-block'},
                textBoldRed: {inline: 'span', classes: 'text-bold-red-upper'},
                textParagraph: {block: 'p'},
                textLink: {inline: 'a', classes: 'text-link', selector: 'a'},
                headding2: {block: 'h2'},
                headding4: {block: 'h4'},
                classH4: {block: 'h4', classes: 'h4'},
            },
            style_formats: [
                {
                    title: 'Mobile/Desktop', items: [
                        {title: 'Desktop block', format: 'desktopBlock'},
                    ],
                },
                {
                    title: 'Text', items: [
                        {title: 'Červeně tučně', format: 'textBoldRed'},
                        {title: 'Odstavec', format: 'textParagraph'},
                        {title: 'Nadpis H2', format: 'headding2'},
                        {title: 'Nadpis H4', format: 'headding4'},
                        {title: 'Class H4', format: 'classH4'},
                    ],
                },
                {
                    title: 'Odkazy', items: [
                        {title: 'Šedý odkaz', format: 'textLink'},
                    ],
                },
            ],


            save_enablewhendirty: true,
            save_onsavecallback: () => {
                const element = tinymce.activeEditor.getElement();
                const name = element.dataset.name;
                const data = tinymce.activeEditor.getContent();
                const url = "?do=saveEditable";
                const requestData = {name: name, content: data};

                naja.makeRequest('POST', url, requestData, {
                        history: false
                    }
                ).then((response) => {
                    if (response.status === 'success') {
                        element.blur();
                        element.classList.add('editable-wrapper--success');
                        setTimeout(() => {
                            element.classList.remove('editable-wrapper--success');
                        }, 500);
                    } else if (response.status === 'error-content') {
                        element.classList.add('editable-wrapper--error-content');
                        element.innerHTML = element.innerHTML + '<br><span class="bg-danger text-white text-center ">' + response.message + '</span>';
                        setTimeout(() => {
                            element.classList.remove('editable-wrapper--error-content');
                        }, 500);
                    } else {
                        element.classList.add('editable-wrapper--error');
                        setTimeout(() => {
                            element.classList.remove('editable-wrapper--error');
                        }, 500);
                    }
                });
            },
        });

        // disable click event on editable elements
        document.addEventListener('click', (event) => {
            const element = event.target as HTMLElement;

            if (element.classList.contains('editable-wrapper') || element.closest('.editable-wrapper')) {
                event.preventDefault();
            }
        });
    }
};
